import styled from 'styled-components';
import { Typography } from '../../../../../stories/atoms';
import { ColumnFlexContainer, RowFlexContainer } from '../../../../../stories/atoms/containerV2/ContainerV2';
import { muiTheme, percentToHex } from '../../../../../theme';
import { EngagementMetrics } from './CustomerEngagement';

export const StyledTypography = styled(Typography)`
  width: 100%;
`;

const getEngagementColors = (metricName: EngagementMetrics) => {
  if (metricName === 'memberRecruited') {
    return {
      backgroundColor: muiTheme.color.infoLightTransparent,
      borderColor: muiTheme.color.infoDark,
      tileColor: percentToHex(muiTheme.color.info, 50),
    };
  } else if (metricName === 'memberIdentification') {
    return {
      backgroundColor: percentToHex(muiTheme.color.warning, 8),
      borderColor: muiTheme.color.warningDark,
      tileColor: percentToHex(muiTheme.color.warning, 50),
    };
  } else {
    return {
      backgroundColor: percentToHex(muiTheme.color.success, 8),
      borderColor: muiTheme.color.validationGreen,
      tileColor: percentToHex(muiTheme.color.success, 50),
    };
  }
};

export const SectionContainer = styled(ColumnFlexContainer)<{
  metricName: EngagementMetrics;
  isSliderView?: boolean;
}>`
  background-color: ${({ metricName }) => getEngagementColors(metricName).backgroundColor};
  border: ${({ metricName }) => `1px solid ${getEngagementColors(metricName).borderColor}`};
  cursor: ${({ isSliderView }) => isSliderView && 'pointer'};
`;

export const StyledMetricTile = styled(RowFlexContainer)<{ metricName: EngagementMetrics }>`
  background-color: ${({ metricName }) => getEngagementColors(metricName).tileColor};
`;
